import { useEffect, useSyncExternalStore } from 'react';

let suppressors = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const isSuppressed = () => suppressors > 0;

export const useSupportAssistantSuppressed = () => useSyncExternalStore(subscribe, isSuppressed, isSuppressed);

export const useSuppressSupportAssistant = (active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    suppressors += 1;
    notify();
    return () => {
      suppressors -= 1;
      notify();
    };
  }, [active]);
};
